import {
    DELETEUSER_SUCCESS,
    DELETEUSER_FAILED,
    RESET_DELETEUSER,
    LOADING_DELETEUSER,
    NETWORK_ERROR_DELETEUSER
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetDeleteUser = () => {
    return { type: RESET_DELETEUSER };
};

const deleteUser = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DELETEUSER });
    await partnerServices
        .post("getDeleteManagementList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(deleteUsersuccess(res.data));
                    break;
                default:
                    dispatch(deleteUserFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DELETEUSER,
                payload: err
            });
        });
};
function deleteUsersuccess(data) {
    return {
        type: DELETEUSER_SUCCESS,
        payload: data
    };
}
function deleteUserFailed(data) {
    return {
        type: DELETEUSER_FAILED,
        payload: data
    };
}

export { resetDeleteUser, deleteUser };
